// Role-Based Participation Across Scopes - Detailed Matrix
// Source: SCOPE section VI. 🧭 Role-Based Participation Across Scopes

export const roleParticipationMatrix = {
  encodedId: 'pf.framework.diagnostic.role_participation',
  title: 'Role-Based Participation Across Scopes',
  description: 'Each role type (Individual Contributor, Team Lead/Manager, Executive) engages with Individual, Team, and Organizational prioritization—but the nature of their participation shifts depending on the level and their scope of influence.',
  structure: 'Matrix (3 roles × 3 scope levels)',
  
  matrix: [
    {
      roleType: 'Individual Contributor',
      scopes: {
        individual: {
          title: 'Individual-Level Prioritization',
          participation: 'Executes and adjusts personal priorities to align with team/manager signals.'
        },
        team: {
          title: 'Team-Level Prioritization',
          participation: 'Contributes upward signals (e.g., capacity, blockers, frontline insight); adapts to team-level shifts.'
        },
        organizational: {
          title: 'Org-Level Prioritization',
          participation: 'Implements org-level priorities; observes impacts; occasionally escalates misalignments or insights.'
        }
      }
    },
    {
      roleType: 'Team Lead / Manager',
      scopes: {
        individual: {
          title: 'Individual-Level Prioritization',
          participation: 'Balances personal IC tasks with leadership duties; models healthy prioritization.'
        },
        team: {
          title: 'Team-Level Prioritization',
          participation: 'Leads team prioritization conversations; allocates resources; arbitrates conflicts; synthesizes up/down signals.'
        },
        organizational: {
          title: 'Org-Level Prioritization',
          participation: 'Translates organizational priorities into actionable team focus; surfaces patterns and risks upward.'
        }
      }
    },
    {
      roleType: 'Executive / Org Leader',
      scopes: {
        individual: {
          title: 'Individual-Level Prioritization',
          participation: 'Prioritizes personal time/attention across strategic initiatives, relationships, and decisions.'
        },
        team: {
          title: 'Team-Level Prioritization',
          participation: 'Engages with teams via skip levels, feedback loops, and steering mechanisms; reinforces key priorities.'
        },
        organizational: {
          title: 'Org-Level Prioritization',
          participation: 'Sets and evolves organizational priorities; manages trade-offs across time horizons, silos, and external forces.'
        }
      }
    }
  ],

  // Key insights from the model
  insights: [
    'Everyone participates at all three levels—Individual, Team, and Org—but how they participate differs by role',
    'Individual Contributors primarily execute and signal upward',
    'Team Leads/Managers serve as translators and synthesizers between levels',
    'Executives set direction at org level while engaging strategically at team and individual levels',
    'The nature of participation shifts based on scope of influence, not just presence'
  ],

  // Relationships to other models
  relatedModels: [
    'pf.framework.diagnostic.role.types',
    'pf.framework.diagnostic.scope.levels',
    'pf.framework.diagnostic.role_scope.matrix'
  ]
};

export default roleParticipationMatrix;
